import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3010ParamStatus: 'idle',
    startProcess3010ParamError: undefined as any,
    loadUserParamsProcess3010ParamStatus: 'idle',
    loadUserParamsProcess3010ParamError: undefined as any,

    process3010ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess3010Param = createAsyncThunk('process3010ParamSlice/startProcess3010Param', async ({ process3010Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3010Param/`,
        prepareData(process3010Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess3010ParamStatus } = getState().process3010ParamSlice
        return startProcess3010ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess3010Param = createAsyncThunk('process3010ParamSlice/loadUserParamsProcess3010Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3010Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess3010ParamStatus } = getState().process3010ParamSlice
        return loadUserParamsProcess3010ParamStatus !== 'pending'
    }
})

const Process3010ParamSlice = createSlice({
    name: 'process3010ParamSlice',
    initialState,
    reducers: {
        resetstartProcess3010Param: (state) => {
            state.job = undefined
            state.startProcess3010ParamError = undefined
        },
        resetstartProcess3010ParamError: (state) => {
            state.startProcess3010ParamError = undefined
        },
        resetloadUserParamsProcess3010Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3010ParamError = undefined
        },
        resetloadUserParamsProcess3010ParamError: (state) => {
            state.loadUserParamsProcess3010ParamError = undefined
        },
        removeFromProcess3010ParamListById: (state, action) => {
            state.process3010ParamList = state.process3010ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3010ParamListByIds: (state, action) => {
            state.process3010ParamList = state.process3010ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process3010ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3010ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3010ParamList = []
            state.startProcess3010ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3010Param.pending, (state) => {
            state.startProcess3010ParamStatus = 'pending'
            state.startProcess3010ParamError = undefined
        })
        builder.addCase(startProcess3010Param.fulfilled, (state, action) => {
            state.startProcess3010ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3010Param.rejected, (state, action) => {
            state.startProcess3010ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3010ParamError = action.error.message
            } else {
                state.startProcess3010ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3010Param.pending, (state) => {
            state.loadUserParamsProcess3010ParamStatus = 'pending'
            state.loadUserParamsProcess3010ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess3010Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess3010ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3010Param.rejected, (state, action) => {
            state.loadUserParamsProcess3010ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3010ParamError = action.error.message
            } else {
                state.loadUserParamsProcess3010ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3010Param,
    resetstartProcess3010ParamError,
    resetloadUserParamsProcess3010Param,
    resetloadUserParamsProcess3010ParamError,
    removeFromProcess3010ParamListById,
    removeFromProcess3010ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process3010ParamSlice.actions
export default Process3010ParamSlice.reducer
